import { ADMISSIONS_ERROR, GETTING_ADMISSIONS, GET_ADMISSIONS } from "../types"

const initialState = {
    admissions: [],
    loadingAdmissions: true,
    admissionsError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_ADMISSIONS:
        return {
            ...state,
            loadingAdmissions :action.payload,
        }
        case GET_ADMISSIONS:
        return{
            ...state,
            loadingAdmissions:false,
            admissionsError:  null,
            admissions: action.payload,
        }
        case ADMISSIONS_ERROR:
        return{
            ...state,
            loadingAdmissions:false,
            admissionsError: action.payload 
        }
        default: return state
    }

}